import { createFileRoute, redirect } from "@tanstack/react-router";
import { LEGACY_SECTION_SLUGS } from "~/features/design-system/registry";

export const Route = createFileRoute("/design-system/")({
  beforeLoad: ({ search }) => {
    // Legacy single-page URLs (`?section=`, `?preview=`) redirect to their
    // closest page in the multi-page reference.
    const legacySlug =
      search.preview === "asset-selector"
        ? "asset-selector"
        : search.section !== undefined
          ? LEGACY_SECTION_SLUGS[search.section]
          : undefined;

    if (typeof legacySlug === "string") {
      throw redirect({
        params: { slug: legacySlug },
        replace: true,
        search: {
          theme: search.theme,
          ...(search.preview !== undefined ? { preview: search.preview } : {}),
        },
        to: "/design-system/$slug",
      });
    }
  },
});
